import React from 'react'
import BackButton from './BackButton'
import './Header.css'

export default function Header({ back, title, eyebrow, action }) {
  return (
    <div className="ui-header">
      <div className="ui-header-left">
        {back && <BackButton label={back.label} onClick={back.onClick} />}
      </div>
      <div className="ui-header-center">
        {eyebrow && <span className="ui-header-eyebrow">{eyebrow}</span>}
        {title && <span className="ui-header-title">{title}</span>}
      </div>
      <div className="ui-header-right">
        {action || null}
      </div>
    </div>
  )
}
